import styles from "../landing-page-mobile-one.module.css";
import { ProjectPreview } from "components/common/project-preview";
import { useState, useEffect } from "react";
import { useCollectionStore } from "entity-store/collections-store/use-collection-store";
import { useTemplateStore } from "entity-store/template-store/use-template-store";
import { ProjectTemplate } from "PosterEditor/model/project-template";
import { CTAButton } from "BEDROCK/shared-components/cta-button";
import { useAnalyticsTracker } from "analytics-tracker";

interface PresetsSectionMobileProps {
  onClickTemplate: () => void;
}

export const PresetsSectionMobile = (props: PresetsSectionMobileProps) => {
  const { loadCollectionByID } = useCollectionStore();
  const { loadTemplatesByIDs } = useTemplateStore();
  const [templates, setTemplates] = useState<ProjectTemplate[]>([]);
  const { trackEvent } = useAnalyticsTracker();

  useEffect(() => {
    // TODO: Replace with new collection ID for mobile landing page
    loadCollectionByID("8725e8ae-df7a-45bc-b789-a0741fa65bfc").then(
      (collection) => {
        if (collection) {
          let ids = collection?.templateIDs;
          loadTemplatesByIDs(ids).then(setTemplates);
        }
      }
    );
  }, []);

  const handleTemplateClick = (templateId: string) => {
    trackEvent("Mobile landing CTA clicked", { section: "presets", button: "template_preview", templateId });
    props.onClickTemplate();
  };

  const handleCTAClick = () => {
    trackEvent("Mobile landing CTA clicked", { section: "presets", button: "view_all_templates" });
    props.onClickTemplate();
  };

  return (
    <section className={styles.presetsSection}>
      <h2 className={styles.presetsTitle}>Featured Design Templates</h2>
      <div className={styles.presetsGrid}>
        {templates.map((template) => (
          <button
            className={styles.presetItem}
            key={template.id}
            onClick={() => handleTemplateClick(template.id)}
          >
            <ProjectPreview
              template={template}
              className={styles.presetPreview}
              allowHoverEffect={true}
            />
          </button>
        ))}
      </div>
      <CTAButton
        variant="SECONDARY"
        title="VIEW ALL TEMPLATES"
        onClick={handleCTAClick}
        className={styles.sectionCTA}
      />
    </section>
  );
};
